import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';
import tableEditOriginOutputs from './tableEditOriginOutputs';

export default {
  title: 'Origin Outputs',
  attributeName: 'vodOrigins',
  fields: [
      {
      attributeName: 'moveFiles',
      label: 'Move Files',
      type: FormInputTypes.BUTTON_POPUP,
      icon: IconType.NEW,
      buttonText:"Move Files",
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Create new Origin files from vodBackend files.',
      //redirectUrl:'lives',
      refreshIfOk:true,
      actionUrl:'movefilesOriginOutputs',
      isEditId:true,
      // visibleWhen: {"field":"composeExperienceType","value":"multicam"},
      formConfig:
        {
          title: 'Move files to Origin Outputs',
          description:'You are moving files to Origin Outputs. This action will copy the files from Vod Backend Outputs to Origin Outputs associated to this VoD. Please confirm to proceed.',
          attributeName: 'moveFilesForm',
          fields: [
            {
              attributeName: 'destinationOriginId',
              helpText: 'Select a valid Origin to move the files to.',
              type: FormInputTypes.SELECT,
              label: 'Origin',
              placeholder: 'Please enter a valid origin',
              multiple: false,
              url: 'listValidOrigins',
              validateUrl:'moveOriginSettingsValidate/vodId',
              emptyValue:true,
              default:'(Empty)', //default value to empty option
              fieldValue:'id',
              fieldName:'name',
              asyncSelect: true,
              options:[],
              sessionParams: ['vodId'],

            },
          ]
        }
    }, 
    {
      attributeName: 'origins',
      type: FormInputTypes.TABLE,
      label: '',
      helpText: '',
      configFile: tableEditOriginOutputs,
    },
  ],
};
